import { render, staticRenderFns } from "./FlexibleSections.vue?vue&type=template&id=09a2687a"
import script from "./FlexibleSections.vue?vue&type=script&lang=js"
export * from "./FlexibleSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports